<tr class="order-line-status-wrap">
  <td *ngIf="orderLine.type === CART_LINE_TYPES.COMMENT">
    <div class="pre-line">{{ orderLine?.details?.comment }}</div>

    <ng-container *ngTemplateOutlet="motiveCake"></ng-container>
  </td>

  <td *ngIf="orderLine.type === CART_LINE_TYPES.EXTRA_PRODUCT">
    <div class="text-muted font-xs cut-text">{{orderLine?.details?.extraGroup?.name}}</div>

    <div class="d-flex justify-content-between">
      <div class="pre-line">{{orderLine?.details?.name}}</div>

      <ui-order-line-status-badge
        *ngIf="orderLine.state"
        [status]="orderLine.state"
      ></ui-order-line-status-badge>
    </div>

    <ng-container *ngTemplateOutlet="motiveCake"></ng-container>
  </td>

  <td *ngIf="orderLine.type === CART_LINE_TYPES.GREETING_CARD">
    <div class="text-muted font-xs" [translate]="'receipt.greetingCard'"></div>
    <div class="d-flex justify-content-between">
      <div [innerHTML]="orderLine?.details.text"></div>

      <ui-order-line-status-badge
        *ngIf="orderLine.state"
        [status]="orderLine.state"
      ></ui-order-line-status-badge>
    </div>
  </td>

  <td *ngIf="orderLine.type === CART_LINE_TYPES.PICTURE">
    <div class="mb-05 d-flex justify-content-between">
      <div>{{orderLine.name || ('receipt.cakeMotive' | translate)}}</div>
      <ui-order-line-status-badge
        *ngIf="orderLine.state"
        [status]="orderLine.state"
      ></ui-order-line-status-badge>
    </div>

    <ng-container *ngTemplateOutlet="motiveCake"></ng-container>
  </td>

  <td *ngIf="orderLine.type === CART_LINE_TYPES.QUESTION">
    <div class="text-muted font-xs">{{orderLine.name}}</div>

    <div class="d-flex justify-content-between">
      <div [innerHTML]="orderLine?.details.answer"></div>

      <ui-order-line-status-badge
        *ngIf="orderLine.state"
        [status]="orderLine.state"
      ></ui-order-line-status-badge>
    </div>
  </td>

  <td *ngIf="orderLine.type === CART_LINE_TYPES.DEPOSIT">
    <div>{{orderLine.name}}</div>
  </td>

  <td class="text-center"
      [class.valign-bottom]="isValignBottom"
      [class.valign-top]="isValignTop"
      [class.greeting-card-valign]="isGreetingCardValign">
    {{orderLine.quantity}}
  </td>

  <ng-container *ngIf="!simplifyView">
    <td class="text-center"
        [class.valign-bottom]="isValignBottom"
        [class.valign-top]="isValignTop"
        [class.greeting-card-valign]="isGreetingCardValign">
      {{price | currencyFormat: currency}}
    </td>

    <td class="text-end"
        [class.valign-bottom]="isValignBottom"
        [class.valign-top]="isValignTop"
        [class.greeting-card-valign]="isGreetingCardValign">
      {{total | currencyFormat: currency}}
    </td>
  </ng-container>
</tr>

<ng-template #motiveCake>
  <div class="motive-cake"
       *ngIf="orderLine.details?.url">
    <div class="d-inline-block"
         [imagePreviewTrigger]="orderLine.details?.url">
      <img [src]="orderLine?.details.url" [alt]="orderLine?.name">
    </div>
  </div>
</ng-template>
